import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import SvgWaveLoader from './SvgWaveLoader';

const VoiceProcessing = ({ progress }) => {
  const { t } = useTranslation();
  return (
    <Box>
      <SvgWaveLoader />
      <Typography variant="subtitle1" mt={-5} align="center">
        {t('processingVoiceClone', { progress })}
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={6} align="center">
        {t('pleaseDoNotExitScreen')}
      </Typography>
    </Box>
  );
};

export default VoiceProcessing;
